/* eslint-disable jsx-a11y/accessible-emoji */
import React, { useState } from "react";
import ProjectLanguages from "../../components/projectLanguages/ProjectLanguages";
import { Fade } from "react-reveal";
import "./GithubRepoCard.css";

export default function GithubRepoCard({ repo, theme }) {
  const [isHovered, setIsHovered] = useState(false);

  // Vérifie si l'URL est valide
  const isValidUrl = repo.url && repo.url.startsWith("https");

  // Fonction pour ouvrir la page dans un nouvel onglet
  function openRepoinNewTab(url) {
    if (url && url !== "#" && url !== "/#") {
      window.open(url, "_blank");
    }
  }

  // URL pour la preview image via Microlink
  const previewImage = `https://api.microlink.io/?url=${encodeURIComponent(
    repo.url
  )}&screenshot=true&embed=screenshot.url`;

  return (
    <div
      className="overflow-hidden transition-all duration-300 shadow-lg repo-card-div hover:shadow-2xl hover:-translate-y-1 rounded-xl"
      style={{ backgroundColor: theme.dark }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Fade bottom duration={1000} distance="30px">
        <div className="flex flex-col px-4 cursor-pointer" onClick={() => openRepoinNewTab(repo.url)}>
          {/* Aperçu de la page ou image */}
          <div className="relative w-full h-56 overflow-hidden bg-[#111] rounded-t-xl">
            {isValidUrl ? (
              <iframe
                src={repo.url}
                title={repo.name}
                loading="lazy"
                className={`w-full h-full transition-all duration-500 ${isHovered ? "opacity-100 scale-105" : "opacity-80"
                  }`}
                sandbox="allow-same-origin allow-scripts allow-popups"
              />
            ) : (
              <img
                src={previewImage}
                alt={repo.name}
                className="object-cover w-full h-full transition-all duration-500 opacity-80 hover:opacity-100"
              />
            )}
            {/* Overlay au survol */}
            <div
              className={`absolute inset-0 bg-black/40 flex items-center justify-center text-white text-sm font-medium transition-opacity duration-500 ${isHovered ? "opacity-100" : "opacity-0"
                }`}
            >
              👀 Voir le projet
            </div>
          </div>

          {/* Contenu texte */}
          <div className="flex flex-col flex-grow p-4">
            <div className="flex items-center gap-2 mb-2">
              <svg
                aria-hidden="true"
                className="octicon repo-svg"
                height="16"
                fill={theme.green}
                viewBox="0 0 12 16"
                width="12"
              >
                <path
                  fillRule="evenodd"
                  d="M4 9H3V8h1v1zm0-3H3v1h1V6zm0-2H3v1h1V4zm0-2H3v1h1V2zm8-1v12c0 .55-.45 1-1 1H6v2l-1.5-1.5L3 16v-2H1c-.55 0-1-.45-1-1V1c0-.55.45-1 1-1h10c.55 0 1 .45 1 1zm-1 10H1v2h2v-1h3v1h5v-2zm0-10H2v9h9V1z"
                />
              </svg>
              <p className="font-semibold repo-name" style={{ color: theme.text }}>
                {repo.name}
              </p>
            </div>

            <p className="mb-3 text-sm leading-relaxed repo-description" style={{ color: theme.text }}>
              {repo.description}
            </p>

            <div className="mt-auto repo-details">
              <p className="mb-2 text-xs repo-creation-date" style={{ color: theme.secondaryText }}>
                Créé le {repo.createdAt.split("T")[0]}
              </p>
              <ProjectLanguages logos={repo.languages} />
            </div>
          </div>
        </div>
      </Fade>
    </div>
  );
}
